<div class="d-none d-md-block d-lg-block d-xl-block d-xxl-block">
  <a href="tel:08008801900" target="_blank" class="text-decoration-none" (click)="onPhoneButtonClick()">
    <div class="box-phone">
      <span class="material-icons"> local_phone </span>
        <div class="box-text-phone">
          <span>Central de Atendimento</span>
          <p>{{ textPhone }}</p>
        </div>
    </div>
  </a>
</div>

<div class="d-md-none d-lg-none d-xl-none d-xxl-none d-flex text-center">
  <a href="tel:08008801900" target="_blank"  (click)="onPhoneButtonClick()">
    <button class="Btn BtnBorder" mat-button>
      <span class="material-icons"> local_phone </span>
      {{ textBtnSac }}
    </button>
  </a>
</div>